import {
  Aquarius,
  Aries,
  Cancer,
  Capricorn,
  Gemini,
  Leo,
  Libra,
  Pisces,
  Sagittarius,
  Scorpio,
  Taurus,
  Virgo,
} from "./constants";

export const Signs: {
  all: string[];
  Cardinal: string[];
  Fixed: string[];
  Mutable: string[];
  Fire: string[];
  Earth: string[];
  Air: string[];
  Water: string[];
} = {
  // All signs
  all: [
    Aries,
    Taurus,
    Gemini,
    Cancer,
    Leo,
    Virgo,
    Libra,
    Scorpio,
    Sagittarius,
    Capricorn,
    Aquarius,
    Pisces,
  ],

  // Signs by quality
  Cardinal: [Aries, Cancer, Libra, Capricorn],
  Fixed: [Taurus, Leo, Scorpio, Aquarius],
  Mutable: [Gemini, Virgo, Sagittarius, Pisces],

  // Signs by element
  Fire: [Aries, Leo, Sagittarius],
  Earth: [Taurus, Virgo, Capricorn],
  Air: [Gemini, Libra, Aquarius],
  Water: [Cancer, Scorpio, Pisces],
};
